export const CodeConstants = {
  CJ_RESULT_ID: 1,
  BGI_RESULT_ID: 2,
  BGI_PHYSICAL_RESULT_ID: 3,
  BGI_EYE_EXAM_RESULT_ID: 4,
  BGI_DRUG_SCREEN_RESULT_ID: 5,
  APPLICATION_RESULT_ID: 6,
  APPLICATION_INITIAL_REVIEW_RESULT_ID: 7,
  APPLICATION_CREDIT_CHECK_RESULT_ID: 8,
  APPLICATION_DQ_CHALLENGE_RESULT_ID: 9,
  POLYGRAPH_RESULT_ID: 10,
  APPLICATION_CLASS_ID: 11,
  APPLICATION_HIRING_PROCESS_TYPE_ID: 12,
  APPLICATION_SERVICE_BREAK_ID: 13,
  DEPARTMENT_TYPE_ID: 14,
}
